import { ContactSection } from '../../components/ContactForm'
import { PricingCalculator } from '../../components/PricingCalculator'
import { EquipmentList } from './sections/EquipmentList'
import { FeaturesSection } from './sections/FeaturesSection'
import { GallerySection } from './sections/GallerySection'
import { HeroSection } from './sections/HeroSection'
import { HowItWorksSection } from './sections/HowItWorksSection'
import { RolloutSection } from './sections/RolloutSection'

// Single landing route — anchored sections in scroll order. PricingCalculator and
// ContactSection own their own #pricing / #contact sections and are imported as-is.
export const HomePage = () => {
  return (
    <main>
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <RolloutSection />
      <PricingCalculator />
      <GallerySection>
        <EquipmentList />
      </GallerySection>
      <ContactSection />
    </main>
  )
}

export default HomePage
